import { render } from "./CommentReplyList.vue?vue&type=template&id=640873df&scoped=true"
import script from "./CommentReplyList.vue?vue&type=script&lang=js"
export * from "./CommentReplyList.vue?vue&type=script&lang=js"

import "./CommentReplyList.vue?vue&type=style&index=0&id=640873df&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640873df"]])

export default __exports__